export const LISTS_TYPE_PREFIX = 'LISTS/';

export const UL = 'UNORDERED-LIST';
export const OL = 'ORDERED-LIST';
export const LI = 'LISTS/LIST-ITEM'; // FIXME: this should have a different prefix to avoid hard coded check, but changing that would need a migration
